import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxConfig from '../util/remote/ajaxConfig';
import ajaxUser from '../util/remote/ajaxUser';
import ajaxSystem from '../util/remote/ajaxSystem';
import ajaxReport from '../util/remote/ajaxReport';

const initialState = { 
    company: null,
    currentPeriod: null,
    userRoles: null,
    activeMenu: null, 
    userListing: null,
    deletedUser: null,
    specialAccounts: null,
    companyTypes: null,
    companyCode: null,

    classLevels: null,
    classes: null,
    subjectList: null,
    subjectCategories: null,
    subjectTypes: null,
    academicTerms: null,
    assessmentList: null,
    assessmentTypes: null,
    currentAcademicPeriod: null,
    currentClassExams: null,
    religions: null,
    countries: null,
    residences: null,
    houses: null,
    reportFormats: null,
    primaryScales: null,
    advancedScales: null,
    schoolProfile: null,
    reportCommentListing: null,
    subjectCount: null,
    showNewKeyModal: false
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const ConfigContext = createContext();

export const ConfigProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [deleteStream, setDeleteStream] = useState({ show: false, stream: null });
  const [newPaper, setNewPaper] = useState({ show: false, subject: null, callback: ()=>{} });
  const [deletePaper, setDeletePaper] = useState({ show: false, paper: null, callback: ()=>{} });
  const [editPaper, setEditPaper] = useState({ show: false, paper: null, callback: ()=>{} });
  const [newUnit, setNewUnit] = useState({ show: false, subject: null, callback: ()=>{} });
  const [editUnit, setEditUnit] = useState({ show: false, unit: null, callback: ()=>{} });
  const [deleteUnit, setDeleteUnit] = useState({ show: false, unit: null, callback: ()=>{} });
  const [modifiedUser, setModifiedUser] = useState({show: false, user: null, Callback: null});

  useEffect(()=>{
    getCompanyProfile();
  }, []);
  

  const getCompanyProfile = async () => {
    // const server_response  = await ajaxConfig.fetchClientProfile();
    // if(server_response.status === "OK"){
    //     dispatch({ type: 'company', payload: server_response.details });
    //     dispatch({ type: 'companyCode', payload: server_response.details.company_code });
    // }
  };


  const getUserRoles = async (refresh) => {
    if(!refresh && Array.isArray(state.userRoles)){
      return
    }
    const server_response  = await ajaxUser.fetchUserRoles([]);
    if(server_response.status === "OK"){
        dispatch({ type: 'userRoles', payload: server_response.details });
    }else{
      dispatch({ type: 'userRoles', payload: '404' });

    }
  };

  const getUsers = async (refresh) => {
    if(!refresh && Array.isArray(state.userListing)){
      return
    }
    const server_response  = await ajaxUser.fetchUsers();
    if(server_response.status === "OK"){
        dispatch({ type: 'userListing', payload: server_response.details });
    }else{
      dispatch({ type: 'userListing', payload: '404' });

    }
  };

  const getClassLevels = async (refresh) => {
    if(!refresh && Array.isArray(state.classLevels)){
      return
    }
    const server_response  = await ajaxConfig.getClassLevels();
    if(server_response.status === "OK"){
        dispatch({ type: 'classLevels', payload: server_response.details });
    }else{
      dispatch({ type: 'classLevels', payload: '404' });
    }
  }

  const getClasses = async (refresh) => {
    if(!refresh && Array.isArray(state.classes)){
      return
    }
    const server_response  = await ajaxConfig.getClassRooms();
    if(server_response.status === "OK"){
        dispatch({ type: 'classes', payload: server_response.details });
    }else{
      dispatch({ type: 'classes', payload: '404' });
    }
  }


  const getSubjects = async (refresh) => {
    if(!refresh && Array.isArray(state.subjectList)){
      return
    }
    const server_response  = await ajaxConfig.getSubjects();
    if(server_response.status === "OK"){
        dispatch({ type: 'subjectList', payload: server_response.details });
    }else{
      dispatch({ type: 'subjectList', payload: '404' });
    }
  }

  const getSubjectTypes = async (refresh) => {
    if(!refresh && Array.isArray(state.subjectTypes)){
      return
    }
    const server_response  = await ajaxConfig.getSubjectTypes();
    if(server_response.status === "OK"){
        dispatch({ type: 'subjectTypes', payload: server_response.details });
    }else{
      dispatch({ type: 'subjectTypes', payload: '404' });
    }
  }
  const getSubjectCategories = async (refresh) => {
    if(!refresh && Array.isArray(state.subjectCategories)){
      return
    }
    const server_response  = await ajaxConfig.getSubjectCategories();
    if(server_response.status === "OK"){
        dispatch({ type: 'subjectCategories', payload: server_response.details });
    }else{
      dispatch({ type: 'subjectCategories', payload: '404' });
    }
  }

  const getAcademicTerms = async (refresh) => {
    if(!refresh && Array.isArray(state.academicTerms)){
      return
    }
    const server_response  = await ajaxConfig.getTerms();
    if(server_response.status === "OK"){
        dispatch({ type: 'academicTerms', payload: server_response.details });
    }else{
      dispatch({ type: 'academicTerms', payload: '404' });
    }
  }

  const getAssessments = async (refresh) => {
    if(!refresh && Array.isArray(state.assessmentList)){
      return
    }
    const server_response  = await ajaxConfig.getExams();
    if(server_response.status === "OK"){
        dispatch({ type: 'assessmentList', payload: server_response.details });
    }else{
      dispatch({ type: 'assessmentList', payload: '404' });
    }
  }

  const getAssessmentTypes = async (refresh) => {
    if(!refresh && Array.isArray(state.assessmentTypes)){
      return
    }
    const server_response  = await ajaxConfig.fetchAssessmentTypes();
    if(server_response.status === "OK"){
        dispatch({ type: 'assessmentTypes', payload: server_response.details });
    }else{
      dispatch({ type: 'assessmentTypes', payload: '404' });
    }
  }

  const getCurrentAcademicPeriod=async()=>{
         const server_response = await ajaxConfig.getCurrentPeriod();
         if(server_response.status==="OK"){
            dispatch({ type: 'currentAcademicPeriod', payload: server_response.details });
         }
  }


  const getCurrentClassExams = async (refresh) => {
    if(!refresh && Array.isArray(state.currentClassExams)){
      return
    }
    const server_response = await ajaxConfig.getCurrentExams();
    if(server_response.status === "OK"){
        dispatch({ type: 'currentClassExams', payload: server_response.details });
    }else{
      dispatch({ type: 'currentClassExams', payload: '404' });
    }
  }

  const getReligions = async (refresh) => {
    if(!refresh && Array.isArray(state.religions)){
      return
    }
    const server_response  = await ajaxConfig.fetchReligions();
    if(server_response.status === "OK"){
        dispatch({ type: 'religions', payload: server_response.details });
    }else{
      dispatch({ type: 'religions', payload: '404' });
    }
  }

  const getCountries = async (refresh) => {
    if(!refresh && Array.isArray(state.countries)){
      return
    }
    const server_response  = await ajaxConfig.fetchCountries();
    if(server_response.status === "OK"){
        dispatch({ type: 'countries', payload: server_response.details });
    }else{
      dispatch({ type: 'countries', payload: '404' });
    }
  }

  const getResidences = async (refresh) => {
    if(!refresh && Array.isArray(state.residences)){
      return
    }
    const server_response  = await ajaxConfig.fetchResidenceListing();
    if(server_response.status === "OK"){
        dispatch({ type: 'residences', payload: server_response.details });
    }else{
      dispatch({ type: 'residences', payload: '404' });
    }
  }

  const getHouses = async (refresh) => {
    if(!refresh && Array.isArray(state.houses)){
      return
    }
    const server_response  = await ajaxConfig.fetchHouses();
    if(server_response.status === "OK"){
        dispatch({ type: 'houses', payload: server_response.details });
    }else{
      dispatch({ type: 'houses', payload: '404' });
    }
  }


  const getReportFormats=async()=>{
    const server_response = await ajaxSystem.getReportFormats();
    if(server_response.status==="OK"){
      dispatch({ type: 'reportFormats', payload: server_response.details });
    }else{
      dispatch({ type: 'reportFormats', payload: '404' });
    }
  }

  const getPrimaryScales=async()=>{

      const server_response = await ajaxSystem.getPrimarySCales();
      if(server_response.status==="OK"){
        dispatch({ type: 'primaryScales', payload: server_response.details });
      }else{
        dispatch({ type: 'primaryScales', payload: '404' });
      }
  }

  const getAdvancedScales=async()=>{
      const server_response = await ajaxSystem.getAdvancedSCales();
      if(server_response.status==="OK"){
        dispatch({ type: 'advancedScales', payload: server_response.details });
      }else{
        dispatch({ type: 'advancedScales', payload: '404' });
      }
  }


  const getSchoolProfile = async (refresh) => {
    if(!refresh && state.schoolProfile){
      return
    }
    const server_response  = await ajaxConfig.getSchoolInfo();
    if(server_response.status === "OK"){
        dispatch({ type: 'schoolProfile', payload: server_response.details });
    }
  }


  const getReportCommentConfig=async(refresh)=>{
    if(!refresh && Array.isArray(state.reportCommentListing)){
      return
    }
    const server_response = await ajaxReport.listReportCommentConfig();
    if(server_response.status==="OK"){
        dispatch({ type: 'reportCommentListing', payload: server_response.details });
    }else{
        dispatch({ type: 'reportCommentListing', payload: '404' });
    }
  }

  const getSubjectCount = async (refresh) => {
    if(!refresh && state.subjectCount){
      return
    }
    const server_response  = await ajaxConfig.countSubjects();
    if(server_response.status === "OK"){
        dispatch({ type: 'subjectCount', payload: server_response.details });
    }
  }

  
  return(
    <ConfigContext.Provider value={{
      ...state,
      deleteStream,
      newPaper,
      deletePaper,
      editPaper,
      newUnit,
      editUnit,
      deleteUnit,
      modifiedUser,
      setDeleteUnit,
      setEditUnit,
      setNewUnit,
      setEditPaper,
      setDeletePaper,
      setNewPaper,
      dispatch, 
      getCompanyProfile,
      getUserRoles,
      getUsers,
      getClassLevels,
      getClasses,
      setDeleteStream,
      getSubjects,
      getSubjectTypes,
      getSubjectCategories,
      getAcademicTerms,
      getAssessments,
      getAssessmentTypes,
      getCurrentAcademicPeriod,
      getCurrentClassExams,
      getReligions,
      getCountries,
      getResidences,
      getHouses,
      getReportFormats,
      getPrimaryScales,
      getAdvancedScales,
      getSchoolProfile,
      getReportCommentConfig,
      getSubjectCount,
      setModifiedUser
      }}>
      {children}
    </ConfigContext.Provider>
  )

}

export const useConfig = ()=>useContext(ConfigContext);

